export default class Polygonal {}
export default class Polygonal {}
